export enum TargetBandMode {
  Buffer = 'buffer',
  MinMax = 'minmax',
}
